import { Box, Stack, styled } from '@mui/material'
import { useAlertBanner } from '@src/contexts/alert-banner-context'
import { ALERT_BANNER_HEIGHT_PX, APP_HEADER_HEIGHT_PX } from '@src/types/constants'
import { useLayoutEffect, useRef } from 'react'
import LoanCalendarTablePrimaryActions from './LoanCalendarTablePrimaryActions'
import LoanCalendarTableSecondaryActions from './LoanCalendarTableSecondaryActions'

const ToolbarContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  left: 0,
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  zIndex: 4,
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1),
  flexDirection: 'column',
  alignItems: 'stretch',
  display: 'flex',
}))

const LoanCalendarTableToolbar = () => {
  const { banner } = useAlertBanner()
  // Stick just below the sticky app header (and alert banner when present)
  const topOffsetPx = APP_HEADER_HEIGHT_PX + (banner.message ? ALERT_BANNER_HEIGHT_PX : 0)
  const toolbarRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const el = toolbarRef.current
    if (!el) return
    const root = document.documentElement
    const update = () => {
      root.style.setProperty('--calendar-region-top', `${topOffsetPx}px`)
      root.style.setProperty('--calendar-toolbar-height', `${el.offsetHeight}px`)
    }
    update()
    const observer = new ResizeObserver(update)
    observer.observe(el)
    return () => {
      observer.disconnect()
      root.style.removeProperty('--calendar-region-top')
      root.style.removeProperty('--calendar-toolbar-height')
    }
  }, [topOffsetPx])

  return (
    <ToolbarContainer ref={toolbarRef}>
      <Stack flexDirection="row" gap={1} justifyContent="space-between">
        <LoanCalendarTablePrimaryActions />
        <LoanCalendarTableSecondaryActions />
      </Stack>
    </ToolbarContainer>
  )
}

export default LoanCalendarTableToolbar
